// @ts-nocheck
import { Button } from 'reactstrap';
import ButtonWrapper from './button.style';

const NoodleButton = ButtonWrapper(Button);
export default NoodleButton;
